import React, { useEffect } from "react";
import Card from "../../../components/Global/Card";
import { FaShoppingCart } from "react-icons/fa";
import { FaPlusCircle } from "react-icons/fa";
import GoBack from "../../../components/Utils/GoBack";
import RegisterOrcamentoForm from "../../../components/Forms/RegisterOrcamentoForm/index";

function RegisterOrcamento() {
  return (
    <div className="flex flex-col w-full gap-3">
      <GoBack path="/orcamentos" />
      <Card title="Gerar Orçamento" icon={<FaPlusCircle className="w-[25px] h-[25px]" />}>
        <div className="p-4 flex flex-col gap-5 w-full">
          <RegisterOrcamentoForm/>
        </div>
      </Card>
    </div>
  );
}

export default RegisterOrcamento;